import { useMemo, useState } from "react";
import BrieChatMenu, { BriePages } from "./BrieChatMenu";
import BrieIcon from "./BrieIcon";
import { Popover } from "@mantine/core";
import { useLocation } from "react-router-dom";
import { useHotkeys } from "@mantine/hooks";
import { atom, useAtom, useAtomValue } from "jotai";
import { IsMobileAtom } from "../../App";

export const brieMenuOpenAtom = atom(false);
export const brieMenuPageAtom = atom<BriePages>("chat-gpt");

const BrieChatMenuButton = () => {
  const [keepOpen] = useState(false);
  const [open, setOpen] = useAtom(brieMenuOpenAtom);
  const isMobile = useAtomValue(IsMobileAtom);
  const location = useLocation();
  useHotkeys([["mod+i", () => setOpen((prev) => !prev)]]);

  const ids = useMemo(() => {
    const regex =
      /\/clouds\/([a-zA-Z0-9]+)\/workspaces\/([a-zA-Z0-9]+)\/pages\/([a-zA-Z0-9]+)\/views\/([a-zA-Z0-9]+)/;
    const matches = location.pathname.match(regex);

    if (matches && matches.length > 1) {
      const [, cloudId, workspaceId, pageId, viewId] = matches;

      return { cloudId, workspaceId, pageId, viewId };
    }

    return null;
  }, [location.pathname]);

  return (
    <div id="brie-button-container">
      <Popover
        position="top-end"
        shadow="md"
        onClose={() => setOpen(false)}
        closeOnClickOutside={!keepOpen}
        floatingStrategy="fixed"
        trapFocus={!isMobile}
        opened={open}
      >
        <Popover.Target>
          <div>
            <button
              id="brie-button"
              className="no-select"
              onClick={() => setOpen((prev) => !prev)}
            >
              {open ? <i className="mdi mdi-chevron-down" /> : <BrieIcon />}
            </button>
          </div>
        </Popover.Target>
        <Popover.Dropdown style={{ padding: 0 }}>
          <BrieChatMenu pageID={ids?.pageId} viewID={ids?.viewId} />
        </Popover.Dropdown>
      </Popover>
    </div>
  );
};

export default BrieChatMenuButton;
